import { render, staticRenderFns } from "./SubjectInfo.vue?vue&type=template&id=42cf20e6&"
import script from "./SubjectInfo.vue?vue&type=script&lang=js&"
export * from "./SubjectInfo.vue?vue&type=script&lang=js&"
import style0 from "./SubjectInfo.vue?vue&type=style&index=0&id=42cf20e6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports